/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ total: NonNullable<unknown> }} Partner_Org_Kpi_Prepaid_Left_BadgeInputs */



/**
* | output |
* | --- |
* | "of {total} agreed" |
*
* @param {Partner_Org_Kpi_Prepaid_Left_BadgeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_org_kpi_prepaid_left_badge = /** @type {((inputs: Partner_Org_Kpi_Prepaid_Left_BadgeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Org_Kpi_Prepaid_Left_BadgeInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`von ${i?.total} vereinbart`)
	return /** @type {LocalizedString} */ (`of ${i?.total} agreed`)
});